import React from 'react';
import Card from '../Card/Card';
import RepeatingFields from '../RepeatingFields/RepeatingFields';
import AddresseeItem from '../AddresseeItem/AddresseeItem';

const Addressee = ({ form }) => {
  return (
    <Card heading="Адресат">
      <RepeatingFields
        form={form}
        formKey={'custNameKeys'}
        addButtonText="Добавить собственника"
        renderOneItem={(index, allowDelete, deleteItem) => (
          <AddresseeItem
            form={form}
            index={index}
            allowDelete={allowDelete}
            deleteItem={deleteItem}
          />
        )}
      />
    </Card>
  );
};

export default Addressee;
